import React, { useMemo } from "react";
import { Platform, StyleSheet, View } from "react-native";
import variables from "../../styles/variables";
import Gap from "../Gap";
import Icon from "../Icon";
import RText from "../RText";
import { RLink } from "../RLink/RLink";

// virtually identical to LiveButton.tsx, except its a link, i.e onPress takes you to watch, rather than
// attempts to play something.

export default function LiveButtonLink({
  openPlayChannel = false,
}: {
  openPlayChannel: boolean;
}) {
  const hoverRef = React.useRef();

  const handleMouseEnter = () => {
    if (hoverRef.current && Platform.OS === "web") {
      hoverRef.current.style.backgroundColor =
        variables.colors.palette.buttons.default.hovered.backgroundColor;
    }
  };

  const handleMouseLeave = () => {
    if (hoverRef.current && Platform.OS === "web") {
      hoverRef.current.style.backgroundColor =
        variables.colors.palette.rtv.secondary; // Revert style
    }
  };

  const link = openPlayChannel
    ? { screen: "Watch", params: { channel: "play-tv" } }
    : { screen: "Watch" };

  const Button = () =>
    useMemo(() => {
      return (
        <RLink
          to={link}
          ref={hoverRef}
          customTextStyle={{ display: "none" }}
          // @ts-ignore
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <View
            style={[
              styles.buttonRound,
              { paddingBottom: Platform.OS === "android" ? 4 : 0 },
            ]}
          >
            <RText
              family="secondary"
              weight="bold"
              size="md"
              color="white"
              style={styles.liveText}
            >
              Live
            </RText>
            <Gap size="xxsmall" />
            <Icon name="play" size="medium" />
          </View>
        </RLink>
      );
    }, []);

  return <Button />;
}

const styles = StyleSheet.create({
  buttonRound: {
    borderRadius: 20,
    minHeight: 35,
    backgroundColor: variables.colors.palette.rtv.secondary,
    minWidth: 85,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  liveText: {
    textTransform: "uppercase",
    paddingRight: 0,
    paddingLeft: 8,
  },
});
